import axios from "axios";
import qs from "qs";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import router from "@/router";
import { getToken, Language } from "@/utils/auth";
import { API_BASE_URL } from "@/utils/config";

let isLoginExpiredDialogVisible = false;

// 清理失效登录态后跳转至指定页面
function handleLoginExpiredRedirect(path) {
  store.dispatch("user/resetToken").then(() => {
    router.push(path).catch(() => {});
  });
}

// create an axios instance
const service = axios.create({
  baseURL: API_BASE_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
});

function generateBasicAuthHeader(username, password) {
  // 将用户名和密码拼接成 "username:password" 的形式
  const credentials = `${username}:${password}`;
  // console.log(credentials, '===>2')
  let base64Credentials = "";
  if (typeof btoa === "undefined") {
    base64Credentials = new Buffer.from(credentials, "binary").toString(
      "base64"
    );
  }
  if (typeof btoa !== "undefined") {
    base64Credentials = btoa(credentials);
  }
  // 使用 btoa() 函数将字符串进行 Base64 编码
  // 构建 Authorization 头部
  const authHeader = `base64Credentials`;
  return authHeader;
}

// request interceptor
service.interceptors.request.use(
  (config) => {
    let token = getToken();
    let language = "";
    if (Language() == "zh_CN") {
      language = "zh-cn";
    } else {
      language = "en-us";
    }
    config.headers["language"] = language;
    // do something before request is sent
    //这里做了请求类型的判断 为请求头添加对应的content-type类型
    if (config.url.indexOf("/oauth2/token") != -1) {
      token = generateBasicAuthHeader("app", "app");
      config.headers["user-token"] = token;
      // console.log(config.headers["Authorization"]);
      return config;
    }

    if (token) {
      config.headers["user-token"] = token;
    }

    // if (config.type == "application/x-www-form-urlencoded") {
    //   config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    //   //qs格式化处理 data
    //   config.data = qs.stringify(config.data);
    // }
    // if (config.type == "application/json") {
    //   config.headers["Content-Type"] = "application/json";
    // }
    // if (config.type == "multipart/form-data") {
    //   config.headers["Content-Type"] = "multipart/form-data";
    // }
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers["user-token"] = getToken();
    // }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code != 1) {
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code == -201 || res.code == -202 || res.code == -204) {
        if (isLoginExpiredDialogVisible) {
          return res;
        }
        isLoginExpiredDialogVisible = true;
        // to re-login
        MessageBox.confirm("登录失效，请重新登录", "退出登录", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            handleLoginExpiredRedirect("/login");
          })
          .catch(() => {
            handleLoginExpiredRedirect("/");
          })
          .finally(() => {
            isLoginExpiredDialogVisible = false;
          });
      }
      return res;
      // return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000,
    // });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js